import flagKeys from '@/constants/flagKeys';
import ManageLoyalty from '@/views/YourCoin/ManageLoyalty/index.vue';
import { Route } from '../route.model';

const manageLoyalty = new Route(
  '/coin/loyalty',
  'manage_loyalty',
  ManageLoyalty,
  {
    isResponsive: flagKeys.responsiveDashboard,
    requiresAuth: true,
    navbar: {
      name: 'Rewards Rate', // TODO apply i18n
      icon: 'reward-ratio',
      description:
        'This is the percentage of Loyalty Coins members will receive based on their order total.'
    },
    pageView: {
      eventLabel: 'Rewards Rate'
    }
  }
);

export { manageLoyalty };
export default manageLoyalty;
